module.exports = __webpack_public_path__ + "img/words3.604cce20.png";